import { Claim, CLAIM_STATUS } from "./models/Claim";
import { ClaimStatusColor } from "./claim-detail/ClaimDetailConstants";

export const CLAIM_FORMATTED_STATUS_DRAFT = 'Draft';
export const CLAIM_FORMATTED_STATUS_IN_PROGRESS = 'In Progress';
export const CLAIM_FORMATTED_STATUS_COMPLETED = 'Completed';
export const CLAIM_FORMATTED_STATUS_DENIED = 'Denied';

export const getClaimStatusColor = (statusId?: number): string => {
  switch (statusId) {
    case CLAIM_STATUS.DRAFT:
      return ClaimStatusColor.PENDING;
    case CLAIM_STATUS.IN_PROGRESS:
      return ClaimStatusColor.INPROGRESS;
    case CLAIM_STATUS.COMPLETED:
      return ClaimStatusColor.COMPLETED;
    case CLAIM_STATUS.DENIED:
      return ClaimStatusColor.DENIED
    default:
      return ClaimStatusColor.PENDING;
  }
}

export const getClaimStatusIdFromFormattedStatus = (status?: string): number => {
  switch (status) {
    case CLAIM_FORMATTED_STATUS_DRAFT:
      return CLAIM_STATUS.DRAFT;
    case CLAIM_FORMATTED_STATUS_IN_PROGRESS:
      return CLAIM_STATUS.IN_PROGRESS;
    case CLAIM_FORMATTED_STATUS_COMPLETED:
      return CLAIM_STATUS.COMPLETED;
    case CLAIM_FORMATTED_STATUS_DENIED:
      return CLAIM_STATUS.DENIED;
    default:
      return -1;
  }
}

export const getClaimStatusTextFromStatusId = (statusId?: number): number => {
  switch (statusId) {
    case 1:
      return CLAIM_STATUS.DRAFT;
    case 2:
      return CLAIM_STATUS.IN_PROGRESS;
    case 3:
      return CLAIM_STATUS.COMPLETED;
    default:
      return -1;
  }
}

export const getClaimNegligenceDescription = (negligence?: number): string => {
  switch (negligence) {
    case 1:
      return 'purely accidental';
    case 2:
      return 'somewhat accidental';
    case 3:
      return 'somewhat negligent';
    case 4:
      return 'negligent';
    case 5:
      return 'purely negligent';
    default:
      return '';
  }
}

export const getClaimStatusHistoryDate = (statusId: number, claim?: Claim): string | undefined => {
  if (!claim) {
    return '';
  }

  return claim.status_history.find(status => status.status_id == statusId)?.status_date;
}

export const claimStatusIdToStatus = (statusId?: number) => {
  switch (statusId) {
    case CLAIM_STATUS.DRAFT:
      return CLAIM_FORMATTED_STATUS_DRAFT;
    case CLAIM_STATUS.IN_PROGRESS:
      return CLAIM_FORMATTED_STATUS_IN_PROGRESS;
    case CLAIM_STATUS.COMPLETED:
      return CLAIM_FORMATTED_STATUS_COMPLETED;
    default:
      return "";
  }
}